import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const HeroSection = () => {
  const scrollToBooking = () => {
    trackEvent("booking_click", { event_label: "Hero CTA" });
    const el = document.querySelector("#booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollDown = () => {
    const el = document.querySelector("#about");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_afro-braiding-pro/artifacts/b3skma7u_IMG-20260420-WA0034.jpg"
          alt="Afro Magic Braiding Hair"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <p className="text-xs uppercase tracking-[0.3em] font-sans text-brand-gold mb-6">
            Southfield, Michigan
          </p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-semibold text-brand-text leading-[1.05] tracking-tight mb-6">
            Where Every Braid
            <br />
            <span className="text-gold-gradient">is Magic</span>
          </h1>
          <p className="font-sans text-base md:text-lg text-brand-text-muted max-w-xl mx-auto mb-10 leading-relaxed">
            Premium African hair braiding with over a decade of expertise.
            Box braids, knotless, cornrows, twists, and more.
          </p>
          <button
            onClick={scrollToBooking}
            data-testid="hero-book-btn"
            className="inline-block bg-brand-gold text-black font-sans font-semibold text-sm tracking-wide px-10 py-4 hover:bg-brand-gold-light transition-colors duration-200"
          >
            Book Appointment Now
          </button>
        </motion.div>

        {/* Scroll indicator */}
        <motion.button
          onClick={scrollDown}
          data-testid="scroll-down-btn"
          aria-label="Scroll down"
          className="absolute bottom-3 right-6 sm:right-10 text-brand-text-muted/60 hover:text-brand-gold transition-colors"
          animate={{ y: [0, 6, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <ChevronDown size={22} />
        </motion.button>
      </div>
    </section>
  );
};

export default HeroSection;
